import { Injectable } from '@angular/core';
import { Calendar } from '../../../models/calendar.model';
import { WEEKENDSDAYS_FIELDS } from '../consts/weekendsdays-fields.const';
import {FormManager, FormService} from "@fgpp-ui/components";

@Injectable()
export class CalendarService {
  get formManager(): FormManager {
    return this.formService.getFormManager();
  }
  private _formManager: FormManager;

    constructor(private formService: FormService) {
    }

    public convertWeekendsdaysToString() {
        const weekendsdays = [];
        Object.keys(WEEKENDSDAYS_FIELDS).forEach((key) => {
            const value = this.formManager.get(WEEKENDSDAYS_FIELDS[key]).getValue();
            if (value === '1') {
                weekendsdays.push(key);
            }
        });
        this.formManager.get(Calendar.WEEKENDSDAYS).setValue(weekendsdays.join());
    }

    public setSelectedWeekendsdays() {
        const weekendsdays = this.formManager.get(Calendar.WEEKENDSDAYS).getValue();
        weekendsdays?.split(',').forEach(code => {
            const field = WEEKENDSDAYS_FIELDS[code];
            this.formManager.get(field).setValue('1');
        });
    }
}
